<template>
    <!-- <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span>{{ params.value }}</span>
    </vs-chip> -->
    <span class="feather-icon select-none relative switch-publish">
      <vs-switch v-model="params.data.IsPublished">
        <!--<span slot="on">Published</span>
        <span slot="off">Un-Published</span>-->
      </vs-switch>
    </span>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  watch: {
    "params.data.IsPublished"() {
      debugger;
      //alert("watch:" + this.params.data.IsPublished);
      this.$store
        .dispatch("sponsorManagement/updateStatus", {
          id: this.params.id,
          IsPublished: this.params.data.IsPublished
        })
        .then(() => {
          this.showChangeStatusSuccess();
        })
        .catch(err => {
          console.error(err);
        });
    }
  },
  methods:{
    showChangeStatusSuccess() {
      this.$vs.notify({
        color: "success",
        title: "Status Changed",
        text: this.params.data.IsPublished ? "Sponsor Published successfully" : "Sponsor Unpublished successfully"
      });
    }
  },
  computed: {
    chipColor () {
      return (value) => {
        if (value === 'active') return 'success'
        else if (value === 'blocked') return 'danger'
        else if (value === 'deactivated') return 'warning'
        else return 'primary'
      }
    }
  }
}
</script>

<style lang="scss" scpoped>
/* .ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success),.15);
    color: rgba(var(--vs-success),1) !important;
    font-weight: 500;
  }
  &.vs-chip-warning {
    background: rgba(var(--vs-warning),.15);
    color: rgba(var(--vs-warning),1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger),.15);
    color: rgba(var(--vs-danger),1) !important;
    font-weight: 500;
  }
}*/
</style>
